import { createStyles, Theme } from '@material-ui/core/styles';

const style = (theme: Theme) => createStyles({

    contentLine: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing.unit * 2,

        '&:last-child': {
            marginBottom: 0,
        },
    },

    paramLabel: {
        marginRight: theme.spacing.unit * 2,
    },

    fileName: {
        marginLeft: theme.spacing.unit * 2,
    },

});

export default style;
